<template>
  <v-form ref="form7">
    <div class="d-flex flex-column ga-6">
      <span class="text-heading text-primary">Voorkeuren</span>
      <v-card class="card w-100 d-flex flex-column ga-10" flat>
        <div class="d-flex flex-column ga-4">
          <span class="text-normal text-primary"
            >Wat zijn jouw grootste uitdagingen op het gebied van gezond
            eten?</span
          >
          <span class="text-extra-small">
            Denk aan zaken zoals tijdgebrek, cravings, stress, sociale
            situaties, of iets anders dat het lastig maakt om gezond te eten.
          </span>
          <v-text-field
            v-model="
              localQuestions[
                'Wat zijn jouw grootste uitdagingen op het gebied van gezond eten?'
              ]
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Wat zijn jouw voorkeuren voor het ontbijt?</span
          >
          <span class="text-extra-small">
            Heb je een voorkeur voor een snel ontbijt, een warme maaltijd, iets
            zoets of hartigs? Of misschien specifieke ingrediënten die je graag
            gebruikt? Laat het ons weten!
          </span>
          <v-text-field
            v-model="
              localQuestions['Wat zijn jouw voorkeuren voor het ontbijt?']
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Wat zijn jouw voorkeuren voor de lunch?</span
          >
          <span class="text-extra-small">
            Zijn er specifieke gerechten of ingrediënten die je favoriet zijn?
            Laat het ons weten!
          </span>
          <v-text-field
            v-model="localQuestions['Wat zijn jouw voorkeuren voor de lunch?']"
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Wat zijn jouw voorkeuren voor het avondeten?</span
          >
          <span class="text-extra-small">
            Heb je een voorkeur voor snelle gerechten, uitgebreide maaltijden,
            iets warms, of bepaalde keukens zoals Italiaans, Aziatisch, of
            Hollands? Zijn er ingrediënten of smaken die je graag terugziet in
            je diner? Deel je voorkeuren met ons!
          </span>
          <v-text-field
            v-model="
              localQuestions['Wat zijn jouw voorkeuren voor het avondeten?']
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>

        <div class="d-flex flex-column ga-4 mt-n6">
          <span class="text-normal text-primary"
            >Wat zijn jouw voorkeuren voor tussendoortjes?</span
          >
          <span class="text-extra-small">
            Heb je een voorkeur voor zoete of hartige snacks? Kies je liever
            voor iets lichts, zoals fruit, of iets vullends, zoals een
            proteïnereep? Laat ons weten wat jij lekker vindt!
          </span>
          <v-text-field
            v-model="
              localQuestions['Wat zijn jouw voorkeuren voor tussendoortjes?']
            "
            :rules="[rules.text_field_rules.required]"
            color="secondary"
            base-color="secondary"
            variant="underlined"
          />
        </div>
      </v-card>
    </div>
  </v-form>
</template>

<script>
import FormRules from "@/util/FormRules";

export default {
  props: {
    questions: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: FormRules.rules,
      localQuestions: { ...this.questions },
    };
  },
  methods: {
    nextStep() {
      this.$emit("nextStep", this.geslacht);
    },
  },
  watch: {
    // Watch for changes in localQuestions and emit updates to the parent
    localQuestions: {
      deep: true,
      handler(newVal) {
        this.$emit("update-questions", newVal);
      },
    },
  },
};
</script>
